import { FormattedMessage } from 'react-intl'
import { EventCategory, RawCategories } from '@/shared/types'
import { ListBox, ListOption } from '@/ui/components'
import { strings } from './CategorySelector.strings'
import { CategoryLabelMap } from './categoryLabelMap'

const categoryOptions: ListOption[] = RawCategories.map((key) => ({
  id: key,
  label: CategoryLabelMap[key as EventCategory],
  value: key,
}))

interface Props {
  onSelect: (selected: string) => void
  defaultValue?: EventCategory
}

export const CategorySelector: React.FC<Props> = ({
  defaultValue,
  onSelect,
}) => {
  return (
    <ListBox
      initialValue={categoryOptions.find(({ id }) => id === defaultValue)}
      label={<FormattedMessage {...strings.label} />}
      options={categoryOptions}
      onSelect={(value) => onSelect(value.value)}
    />
  )
}
